import React from 'react';

import styles from './equipment-line-base.module.scss';

interface OwnProps {
    title: React.ReactNode;
    quantity?: React.ReactNode;
    prices?: React.ReactNode;
}

type Props = OwnProps;

const EquipmentLineBase: React.FC<Props> = (props) => {
    const { title, quantity, prices } = props;

    return (
        <div className={styles.chargeRow}>
            <div className={styles.title}>{title}</div>
            {quantity}
            <div className={styles.priceColumnContainer}>{prices}</div>
        </div>
    );
};

export { EquipmentLineBase };
